import { COGNITO_LAST_AUTH_USER_KEY } from '#lib/websites/news/constants/auth.js';

/**
 * Whether Amplify has a Cognito session stored for the configured user pool
 * client.
 *
 * WHY: `Auth.currentSession()` is async, so between mount and its resolution we
 * cannot tell a signed-out visitor from a signed-in one whose session is still
 * being restored. The saved-tags bar needs that distinction *synchronously* on
 * the first paint: it renders default tags immediately for signed-out visitors,
 * but must not flash them at a signed-in user who is about to get their own.
 *
 * Amplify's default storage is `localStorage`, where it records the current
 * user under `CognitoIdentityServiceProvider.<clientId>.LastAuthUser`. Presence
 * of that key means a session is on disk — it may still turn out to be expired
 * and unrefreshable, which is why this is only ever a hint that resolves once
 * `Auth.currentSession()` settles, never a source of authorisation.
 */
export const hasStoredCognitoSession = (): boolean => {
	try {
		return !!window.localStorage.getItem(COGNITO_LAST_AUTH_USER_KEY);
	} catch {
		// Storage can throw outright when cookies/site data are blocked. Treating
		// that as "no session" keeps the bar visible rather than withholding it
		// forever on a browser that will never restore one anyway.
		return false;
	}
};
